import React from 'react';
import PhoneInput from 'react-phone-input-2';

const Step2 = ({ formData, setFormData, formErrors, handleChange, handlePhoneChange }) => {
    return (
        <div className="space-y-6">
            <div className="border-b border-gray-200 pb-4">
                <h2 className="text-xl font-bold text-blue-900">ETAPE 2</h2>
                <h3 className="text-lg font-semibold text-[#287094]">
                    Contact d'urgence
                </h3>
                <p className="text-sm text-gray-600">
                    Complétez les informations relatives à la personne qui voyage
                </p>
                <p className="text-xs text-red-500 mt-1">
                    Les champs marqués * sont obligatoires
                </p>
            </div>

            <div>
                <h4 className="text-md font-semibold text-[#287094] border-b border-gray-200 pb-2 mt-8">
                    Personne à prévenir en cas d'urgence
                </h4>
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                NOM <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="contact_urgence.nom"
                                value={formData.contact_urgence.nom}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 bg-gray-50 border rounded-lg focus:ring-2 focus:ring-[#96B734] ${
                                    formErrors.contact_nom ? 'border-red-500' : 'border-gray-300'
                                }`}
                                required
                            />
                            {formErrors.contact_nom && (
                                <p className="text-xs text-red-500 mt-1">{formErrors.contact_nom}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                PRÉNOM(S) <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="contact_urgence.prenom"
                                value={formData.contact_urgence.prenom}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 bg-gray-50 border rounded-lg focus:ring-2 focus:ring-[#96B734] ${
                                    formErrors.contact_prenom ? 'border-red-500' : 'border-gray-300'
                                }`}
                                required
                            />
                            {formErrors.contact_prenom && (
                                <p className="text-xs text-red-500 mt-1">{formErrors.contact_prenom}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                NUMÉRO DE TÉLÉPHONE <span className="text-red-500">*</span>
                            </label>
                            <PhoneInput
                                country="ne"
                                value={formData.contact_urgence.telephone}
                                onChange={(value) => handleChange({
                                    target: {
                                        name: 'contact_urgence.telephone',
                                        value
                                    }
                                })}
                                containerClass="w-full"
                                inputClass={`w-full px-3 py-2 bg-gray-50 border rounded-lg focus:ring-2 focus:ring-[#96B734] ${
                                    formErrors.contact_telephone ? 'border-red-500' : 'border-gray-300'
                                }`}
                                buttonClass
                            />
                            {formErrors.contact_telephone && (
                                <p className="text-xs text-red-500 mt-1">{formErrors.contact_telephone}</p>
                            )}
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                LIEN AVEC LA PERSONNE <span className="text-red-500">*</span>
                            </label>
                            <select
                                name="contact_urgence.lien"
                                value={formData.contact_urgence.lien}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 bg-gray-50 border rounded-lg focus:ring-2 focus:ring-[#96B734] ${
                                    formErrors.contact_lien ? 'border-red-500' : 'border-gray-300'
                                }`}
                                required
                            >
                                <option value="">Sélectionnez</option>
                                <option value="Parent">Parent</option>
                                <option value="Conjoint">Conjoint</option>
                                <option value="Enfant">Enfant</option>
                                <option value="Ami">Ami</option>
                                <option value="Autre">Autre</option>
                            </select>
                            {formErrors.contact_lien && (
                                <p className="text-xs text-red-500 mt-1">{formErrors.contact_lien}</p>
                            )}
                        </div>

                        {formData.contact_urgence.lien === 'Autre' && (
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                    PRÉCISEZ LE LIEN <span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    name="contact_urgence.autre_lien"
                                    value={formData.contact_urgence.autre_lien}
                                    onChange={handleChange}
                                    className={`w-full px-3 py-2 bg-gray-50 border rounded-lg focus:ring-2 focus:ring-[#96B734] ${
                                        formErrors.contact_autre_lien ? 'border-red-500' : 'border-gray-300'
                                    }`}
                                    required
                                />
                                {formErrors.contact_autre_lien && (
                                    <p className="text-xs text-red-500 mt-1">{formErrors.contact_autre_lien}</p>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Step2;
